import { LoadingOverlay } from '@eventbrite/eds-loading-overlay';
import React, { FunctionComponent } from 'react';
import ColorfulSpinner from '../../resources/colorfulSpinner';
import LogoMarkToCheckbox from '../../resources/logoMarkToCheckbox';
import { getLoadingOverlayStyle } from '../../utils/rebrand';
import rebrandStyles from './LoadingPage.rebranding.module.scss';

export const LoadingPage: FunctionComponent<{
    isAppRebrandActive: boolean;
    isNewRebrandingLogoAnimationEnabled: boolean;
}> = ({ isAppRebrandActive, isNewRebrandingLogoAnimationEnabled }) => {
    const styles = isAppRebrandActive ? rebrandStyles : {};

    return isAppRebrandActive ? (
        isNewRebrandingLogoAnimationEnabled ? (
            <div className={styles?.wrapperLoadingAnimation}>
                <LogoMarkToCheckbox
                    endFrame={80}
                    isAppRebrandActive={isAppRebrandActive}
                />
            </div>
        ) : (
            <div className={styles?.wrapperLoadingAnimation}>
                <ColorfulSpinner />
            </div>
        )
    ) : (
        <LoadingOverlay
            isShown={true}
            style={getLoadingOverlayStyle(isAppRebrandActive)}
            isAppRebrandActive={isAppRebrandActive}
        />
    );
};

export default LoadingPage;
